import {
    ADD_REMOVE_TOOL_MOVED,
    APPTOOLBAR_RESET_APP_STATE,
} from "../lib/types";

const initialState = {
    x: 0,
    y: 0,
    height: 100,
    width: 150,
};

export default ( state = initialState, action ) => {
    switch (action.type) {
        case ADD_REMOVE_TOOL_MOVED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y,
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/add-remove-tool-reducer.js